<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
      v-if="pagination.total !== 0"
      :class="$vuetifyDisplay.smAndDown ? 'text-center' : 'text-left'"
    >
      Items {{ pageCursors.start }} to {{ pageCursors.end }} of
      {{ pagination.total }}
    </v-col>

    <v-col
      cols="12"
      md="6"
      v-if="pagination.total !== 0"
      class="d-flex"
      :class="$vuetifyDisplay.smAndDown ? 'justify-center' : 'justify-end'"
    >
      <v-pagination
        class="i-pagination text-right"
        :value="currentPage"
        :length="pagination.totalPages"
        :total-visible="totalVisible"
        @input="(page) => $emit('paginate', page)"
      >
      </v-pagination>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    currentPage: Number,
    pagination: Object,
    pageSize: Number
  },

  computed: {
    pageCursors() {
      return {
        start: (this.currentPage - 1) * this.pageSize + 1,
        end:
          this.pagination.total < this.currentPage * this.pageSize
            ? this.pagination.total
            : this.currentPage * this.pageSize
      }
    },

    totalVisible() {
      return this.$vuetifyDisplay.smAndDown ? 5 : 7
    }
  }
}
</script>
